import React from 'react';

import RestClient from '../../rest/RestClient';

//https://momentjs.com/
import moment from 'moment';
import MicroEvent  from '../../other/microevent';
import CommonHelper from '../../helpers/CommonHelper';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import {Globs, KEY} from '../../Globs';
import Config from '../../Config';
import ifvisible from "ifvisible.js"
import Entrance from './../Entrance';

export default class PanelPrice extends React.Component {

  constructor(props) {
    super(props);

    MicroEvent.mixin(PanelPrice);

    this.state = {
      buy1m_disabled: true,
      buy2m_disabled: true,
      buy3m_disabled: true,
      buy6m_disabled: true,
    };

    this.handlePurchase1M = this.handlePurchase1M.bind(this);
    this.handlePurchase2M = this.handlePurchase2M.bind(this);
    this.handlePurchase3M = this.handlePurchase3M.bind(this);
    this.handlePurchase6M = this.handlePurchase6M.bind(this);
  }

  componentDidMount() {
    this.updateBuyButtons();

    var refId = setInterval(() =>
    {
      this.updateBuyButtons();
    },
    10*1000);

    this.setState({refInterval_forBuyButtonsUpdate:refId});
  }

  componentWillUnmount(){
    var id = (this.state.refInterval_forBuyButtonsUpdate);
    if(!CommonHelper.isNull(id)){
      clearInterval(id);
    }
  }
  
  updateBuyButtons(){

    if(!ifvisible.now()) { return ;}

    var zeroTimeleft = (Entrance.purchaseTimeLeft()<= 0);
    //console.log('zeroTimeleft'+zeroTimeleft);
    //var zeroTimeleft = (Entrance.purchaseTimeLeft()<= 0);
    this.setState({buy1m_disabled: !zeroTimeleft || CommonHelper.isNull(Entrance.purchaseEndTime())});
    this.setState({buy2m_disabled: !zeroTimeleft});
    this.setState({buy3m_disabled: !zeroTimeleft});
    this.setState({buy6m_disabled: !zeroTimeleft});
  }

  handlePurchase1M(){
    this.handlePurchase('1mn');
  }

  handlePurchase2M(){
    this.handlePurchase('2mn'); 
  }

  handlePurchase3M(){
    this.handlePurchase('3mn');
  }

  handlePurchase6M(){
    this.handlePurchase('6mn');
  }

  handlePurchase(nMonth){
    var w = window.open(Config.dirHostedAt+'/purchase/'+nMonth, '_self');
  }

  render() {
    return (
        <div className="panel-price">
          <Container>
            <Row>
              <Col xs="12" lg="4">
                <div className="sc-box sc-box--alternate">
                  {/*<div className='sc-box-price-top-title'>1-month subscription</div>*/}
                  {/*<div className='sc-box-price-top-text'>1 month of activity on one account</div>*/}
                  <div className='sc-box-price'>$9.99</div>
                  <div className='sc-box-title'>1 month of activity on one account</div>
                  <button id="green"
                          className="sc-btn sc-btn-big sc-btn-border-red"
                          disabled={Globs.get(KEY.BUSY) || this.state.buy1m_disabled}
                          type='submit'
                          onClick={this.handlePurchase1M}>Buy plan
                  </button>
                  {/*<div className='sc-box-price-bottom-title'>No discount</div>*/}
                  {/*<div className='sc-box-price-bottom-text'>A month of subscription means 30 days from the moment right after the payment is accepted.</div>*/}
                </div>
              </Col>
              <Col xs="12" lg="4">
                <div className="sc-box sc-box--alternate">
                  <div className='sc-box-price'>$26.99</div>
                  <div className='sc-box-title'>3 months of activity on one account</div>
                  <button id="green"
                    className="sc-btn sc-btn-big sc-btn-border-red"
                    disabled={Globs.get(KEY.BUSY) || this.state.buy1m_disabled}
                    type='submit'
                    onClick={this.handlePurchase3M}>Buy plan
                  </button>
                </div>
              </Col>
              <Col xs="12" lg="4">
                <div className="sc-box sc-box--alternate">
                  <div className='sc-box-price'>$53.99</div>
                  <div className='sc-box-title'>6 months of activity on one account</div>
                  <button id="green"
                    className="sc-btn sc-btn-big sc-btn-border-red"
                    disabled={Globs.get(KEY.BUSY) || this.state.buy1m_disabled}
                    type='submit'
                    onClick={this.handlePurchase6M}>Buy plan
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
    )
  }
}
